import defaultClient from '@/plugins/axios/defaultClient'

export default {
  patchDocuments({ uuid, data }) {
    const formData = new FormData()
    for (const k in data) {
      formData.append(k, data[k])
    }

    return defaultClient.patch(`/documents/${uuid}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getDocuments({ uuid }) {
    return defaultClient.get(`/documents/${uuid}/`)
  },
  postEasyLogin() {
    return defaultClient.post('/documents/easy-login/')
  },
  postIssueIncomeCertification({ uuid, file }) {
    return defaultClient.post(`/documents/${uuid}/issue-income-certification/`, file)
  },
}
